import { Box, Button, CircularProgress, Sheet, Typography } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import BuildingDialog from "../Dialogs/BuildingDialog";
import { Building } from "../Pages/BuildingList";
import { useRole, isAdminRole } from "../Contexts/RoleContext";

interface BuildingHeaderProps {
	buildingId: string;
}
export default function BuildingHeader(props: BuildingHeaderProps) {
	const [bld, setBld] = React.useState<Building>();
	React.useEffect(() => getData(), [props.buildingId]);
	const [open, setOpen] = React.useState(false);
	const { effectiveRole } = useRole();

	const getData = () => {
		fetch("/Building/GetBuildingData", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ buildingsId: props.buildingId }),
		})
			.then((x) => x.json())
			.then((x) => setBld({ ID: x.buildings_id, Active: x.is_active, Name: x.building_name, Address1: x.address1, Address2: x.address2, PrimaryContact: x.primary_contact, City: x.city, Zip: x.zip, State: x.state } as Building));
	};

	let addy = "";
	if (bld) {
		addy += bld.Address1;
		if (!Util.isNullOrEmpty(bld.Address2?.trim())) {
			addy += ", " + bld.Address2;
		}

		addy += ", " + bld.City + ", " + bld.State + " " + bld.Zip;
	}

	return (
		<Sheet sx={{ borderRadius: "sm", boxShadow: "md", display: "flex", p: 1, justifyContent: bld ? "normal" : "center", mb: 1, flexDirection: "column", gap: 1 }} variant="outlined">
			{!bld && <CircularProgress />}
			{bld && (
				<>
					<BuildingDialog
						open={open}
						bld={bld}
						close={(bid: string) => {
							setOpen(false);
							if (bid) getData();
						}}
					/>
					<Typography level="h3">
						{bld.Name}{" "}
						{isAdminRole(effectiveRole) && (
							<Button sx={{ ml: 1 }} onClick={() => setOpen(true)}>
								Edit Building
							</Button>
						)}
					</Typography>

					<Box sx={{ display: "flex", gap: 2 }}>
						<Box>
							<Typography level="body-xs">Address</Typography>
							<Typography level="body-sm">{addy}</Typography>
						</Box>
						<Box>
							<Typography level="body-xs">Primary Contact</Typography>
							<Typography level="body-sm">{bld.PrimaryContact}</Typography>
						</Box>
					</Box>
				</>
			)}
		</Sheet>
	);
}
